export const makeNewAgentRoute = (
  currId: string,
  newId: string,
  path: string
) => {
  return path.replaceAll(currId, newId);
};
